










































































































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { url } from '~/utils/url';
import { ProductDetailGiftOption } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppLink,
  },
  props: {
    giftOptions: {
      type: Object as PropType<ProductDetailGiftOption>,
      required: true,
    },
  },
  setup(props) {
    const hasGiftboxOption = computed(() =>
      Boolean(
        props.giftOptions.gift_box.is_paper_box ||
          props.giftOptions.gift_box.is_wooden_box ||
          props.giftOptions.gift_box.is_dedicated_box
      )
    );
    const hasAnyOption = computed(() => {
      return hasGiftboxOption.value || props.giftOptions.is_paper_bag;
    });

    return {
      hasGiftboxOption,
      hasAnyOption,
      url,
    };
  },
});
